import { callApi } from "@/services/api"
import { CasinoGame } from "@/services/types"
import { CasinoGameSlug } from "@/services/enums"

type CasinoGameResult = {
  data: CasinoGame
}

export async function getCasinoGame(): Promise<CasinoGameResult> {
  const response = await callApi.getCasinoGame(CasinoGameSlug.CoinFlip)

  return {
    data: response.data.data,
  }
}
